// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1pDc6","col":"styles_col__8KBq8","fulfillmentStatus":"styles_fulfillmentStatus__1nnxi","emailCol":"styles_emailCol__1gGIE"};